import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Layout } from 'spark-core-dx/components';

import { DashboardDomainContextProvider } from './DashboardDomainProvider';
import { DashboardSourceDataContextProvider } from './DashboardSourceDataProvider';
import { VisualFormContextProvider } from './contexts/VisualFormContext';
import { CardLayoutContextProvider } from './contexts/CardLayoutContext';
import { VisualExportContextProvider } from './contexts/VisualExportContext';
import { FullscreenContextProvider } from './contexts/FullScreenContext';

const DashboardDomain = () => {
  const location = useLocation();
  const isDashboardWorkspace = /\/dashboard\/.+/.test(location.pathname) && location.pathname !== '/dashboard';

  return (
    <DashboardDomainContextProvider>
      <DashboardSourceDataContextProvider>
        <VisualFormContextProvider>
          <FullscreenContextProvider>
            <VisualExportContextProvider>
              <CardLayoutContextProvider>
                <Layout layoutOverride="standard" hideFooter={isDashboardWorkspace}>
                  {isDashboardWorkspace && (
                    <style>
                      {`.core-layout.standard-layout .core-screen > .footer { display: none !important; }`}
                    </style>
                  )}
                  <Outlet />
                </Layout>
              </CardLayoutContextProvider>
            </VisualExportContextProvider>
          </FullscreenContextProvider>
        </VisualFormContextProvider>
      </DashboardSourceDataContextProvider>
    </DashboardDomainContextProvider>
  );
};

export default DashboardDomain;
